import { render, staticRenderFns } from "./profile-default-message-locale.vue?vue&type=template&id=3a12b1df&"
import script from "./profile-default-message-locale.vue?vue&type=script&lang=js&"
export * from "./profile-default-message-locale.vue?vue&type=script&lang=js&"
import style0 from "./profile-default-message-locale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports